import React from "react";

import Content from "../../pages/sticker_maker/Content";
import Community from "../../pages/sticker_maker/Community";
import ShowStickerPacks from "../../pages/sticker_maker/StickerPacks/Show";

import PacksReviews from "../../pages/sticker_maker/Reviews/PacksReviews";
import StickersReviews from "../../pages/sticker_maker/Reviews/StickersReviews";

import Assets from "../../pages/sticker_maker/Assets";
import Svgs from "../../pages/sticker_maker/Assets/Svgs";
import Extras from "../../pages/sticker_maker/Assets/Extras";

import Users from "../../pages/sticker_maker/Users";
import ShowUser from "../../pages/sticker_maker/Users/Show";

import Reports from "../../pages/sticker_maker/Reports";

const stickerMakerRoutes = [
  { path: '/sticker_maker/content',             element: <Content /> },
  { path: '/sticker_maker/content/recents',     element: <Content collection='recents' /> },
  { path: '/sticker_maker/content/trending',    element: <Content collection='trending' /> },
  { path: '/sticker_maker/content/popular',     element: <Content collection='popular' /> },

  { path: '/sticker_maker/community',           element: <Community /> },
  { path: '/sticker_maker/community/recents',   element: <Community collection='recents' /> },
  { path: '/sticker_maker/community/trending',  element: <Community collection='trending' /> },
  { path: '/sticker_maker/community/popular',   element: <Community collection='popular' /> },

  { path: '/sticker_maker/reviews/packs', element: <PacksReviews /> },
  { path: '/sticker_maker/reviews', element: <StickersReviews /> },

  { path: '/sticker_maker/sticker_packs/:id', element: <ShowStickerPacks /> },

  { path: '/sticker_maker/assets',        element: <Assets /> },
  { path: '/sticker_maker/assets/svg',    element: <Svgs /> },
  { path: '/sticker_maker/assets/extras', element: <Extras /> },

  { path: '/sticker_maker/users',     element: <Users /> },
  { path: '/sticker_maker/users/:id', element: <ShowUser /> },

  { path: '/sticker_maker/reports',     element: <Reports /> },
]

export default stickerMakerRoutes;
